<template>
    <div class="basicData" v-wechat-title="$t('联机信息')">
        <div class="common_title account_custom">{{ $t('联机信息') }}</div>
        <div class="form_box">
            <div class="machine-id">{{ $t('设备编号') }}：{{sn}}</div>
        </div>
        <div class="common_title account_custom">{{ $t('设备平均时长统计') }}</div>
        <div class="canvas-box">
            <div class="btn_box" v-permissions="3301">
              <span id="years" :class="{'span_bg': dateType === '1'}" @click="typeChange('1')">{{$t('年计')}}</span>
              <span id="fourMonth" :class="{'span_bg': dateType === '2'}" @click="typeChange('2')">{{$t('季计')}}</span>
              <span id="month" :class="{'span_bg': dateType === '3'}" @click="typeChange('3')">{{$t('月计')}}</span>
            </div>
            <span id="desc" v-permissions="3301">{{$t('注：可滚动鼠标滚轮缩放图表')}}</span>
            <div id="main" style="height:450px;width: 90%;margin: 0 auto;position: relative;" v-permissions="3301">
                <span id="noData" v-show="noData">{{$t('暂无数据')}}</span>
            </div>
            <div class="time_box" v-permissions="3301">
                <div>
                    <div class="dayTime1">
                        <p><span class="span1"></span><span class="span2">{{dateType === '1' ? $t('月均运行时长') : $t('日均运行时长')}}</span>
                        </p>
                    </div>
                    <div id="powerTimeAve">{{powerTimeAve}}h</div>
                </div>
                <div>
                    <div class="dayTime2">
                        <p>
                          <span class="span1"></span><span class="span2">{{dateType === '1' ? $t('月均故障时长') : $t('日均故障时长')}}</span>
                        </p>
                    </div>
                    <div id="breakDownTimeAve">{{breakDownTimeAve}}h</div>
                </div>
                <div>
                    <div class="dayTime3">
                        <p>
                          <span class="span1"></span><span class="span2">{{dateType === '1' ? $t('月均空闲时长') : $t('日均空闲时长')}}</span>
                        </p>
                    </div>
                    <div id="proTimeAve">{{proTimeAve}}h</div>
                </div>
                <div>
                    <div class="dayTime4">
                        <p>
                          <span class="span1"></span><span class="span2">{{dateType === '1' ? $t('月均脱机时长') : $t('日均脱机时长')}}</span>
                        </p>
                    </div>
                    <div id="stopTimeAve">{{stopTimeAve}}h</div>
                </div>
            </div>
        </div>
        <div class="common_title account_custom" v-permissions="3302">{{ $t('设备报警') }}</div>
        <div class="ise-mt5" v-permissions="3302">
          <el-table :data="list" v-loading="loading" :cell-style="{borderSpacing:'5px'}">
                <el-table-column :label="$t('序号')" align="center" width="80">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('报警时间')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.errorTime || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('报警号')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.errorCode || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('报警信息')" align="center">
                    <template slot-scope="scope">
                        <span :title="scope.row.errorDetail || '--'">{{ scope.row.errorDetail || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination_box">
              <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :page-sizes="[10, 20, 30, 40, 50]"
                      :page-size="10"
                      :current-page="parameters.page"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="pageInfo.total">
              </el-pagination>
          </div>
        </div>
        <div class="edit_btn_box">
            <button type="button" class="back_btn" @click="$router.push('/manageCusMachine')">{{ $t('返回') }}</button>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            sn: this.$route.query.sn,
            loading: false,
            list: [],
            pageInfo: {
                total: 0
            },
            parameters: {
              page: 1,
              rows: 10,
              mtNo: this.$route.query.sn
            },
            dateType: '3',
            powerTimeAve: '',
            breakDownTimeAve: '',
            proTimeAve: '',
            stopTimeAve: '',
            noData: false,
        }
    },
    mounted () {
        this.initMounted()
    },
    methods: {
        initMounted () {
            if (this.sn) {
              this.read(this.dateType)
              this.getList()
            }
        },
        handleSizeChange (val) {
            this.parameters.rows = val
            this.getList()
        },
        handleCurrentChange (val) {
            this.parameters.page = val
            this.getList()
        },
        getList () {
            this.loading = true
            this.$store.dispatch('a:manageCusMachine/alert', this.parameters).then(
                res => {
                    this.list = res.list || []
                    this.pageInfo = res.pageInfo
                    this.loading = false
                },
                rej => {
                    this.loading = false
                }
            )
        },
        read (timeType) {
            this.$store.dispatch('a:manageCusMachine/runTime', {mtSn: this.sn, timeType}).then(
                res => {
                  if (res) {
                    this.noData = false
                    this.stopTimeAve = res.stopTimeAve
                    this.breakDownTimeAve = res.breakDownTimeAve
                    this.proTimeAve = res.idleTimeAve
                    this.powerTimeAve = res.runningTimeAve
                    this.renderEcharts(res)
                  } else {
                    this.noData = true
                  }
                },
                rej => {
                    this.noData = true
                    this.$message.error(rej.errorInfo);
                }
            )
        },
        typeChange (type) {
          this.dateType = type
          this.read(type)
        },
        renderEcharts (res) {
          let chartsBox = document.getElementById('main')
          let myCharts = this.$ECahrts.init(chartsBox)
          let option = {
              color: ['#D5F2B1', '#F7907C', '#FFE4B1', '#ccc'],
              tooltip: {
                  trigger: 'axis',
                  axisPointer: { // 坐标轴指示器，坐标轴触发有效
                      type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                  },
              },
              legend: {
                  data: [this.$t('运行时间'), this.$t('故障时间'), this.$t('空闲时间'), this.$t('脱机时间')],
                  itemGap: 30,
                  right: '1%'
              },
              grid: {
                  left: '1%',
                  right: '2.3%',
                  bottom: '8%',
                  containLabel: true,
                  show : false
              },
              dataZoom: [
                  {
                      type: 'inside'
                  }
              ],
              xAxis: [
                  {
                      type: 'category',
                      data: [],
                      axisLine: {
                          show: true
                      },
                      axisTick: {
                          show: false
                      },
                      axisLabel: {
                          textStyle: {
                              color: '#333'
                          }
                      },
                      splitLine: {
                          show: true,
                          interval: 0,
                          lineStyle: {
                              color: '#5C6A7E',
                              type: 'solid',
                              width: 1,
                              opacity: 0.5
                          }
                      }
                  }
              ],
              yAxis: [
                  {
                      type: 'value',
                      show: true,
                      axisLine: {
                          show: false
                      },
                      axisTick: {
                          show: false
                      },
                      splitLine: {
                          show: false
                      },
                      axisLabel: {
                          textStyle: {
                              color: '#333'
                          }
                      }
                  }
              ],
              series: [
                  {
                      name: this.$t('加工时长'),
                      type: 'bar',
                      data: []
                  },
                  {
                      name: this.$t('运行时长'),
                      type: 'bar',
                      data: []
                  },
                  {
                      name: this.$t('空闲时长'),
                      type: 'bar',
                      data: []
                  },
                  {
                      name: this.$t('停机时长'),
                      type: 'bar',
                      barCategoryGap: '50%',
                      data: []
                  }
              ]
          }
          this.setEchartsData(res, option)
          myCharts.setOption(option)
        },
        setEchartsData(res, option) {
          let ds_data = res.list
          let axis_x_data = []
          let powerTime_arr = {
              name: this.$t('运行时间'),
              type: 'bar',
              data: []
          }
          let breakDownTime_arr = {
              name: this.$t('故障时间'),
              type: 'bar',
              data: []
          }
          let processTime_arr = {
              name: this.$t('空闲时间'),
              type: 'bar',
              data: []
          }
          let stopTime_arr = {
              name: this.$t('脱机时间'),
              type: 'bar',
              data: []
          }
          for(let i = 0; i < ds_data.length; i++){
              axis_x_data.push(ds_data[i].date)
              powerTime_arr.data.push(ds_data[i].runningTime)
              breakDownTime_arr.data.push(ds_data[i].breakDownTime)
              processTime_arr.data.push(ds_data[i].idleTime)
              stopTime_arr.data.push(ds_data[i].stopTime)
          }
          
          option.xAxis[0].data = axis_x_data
          option.series[0] = powerTime_arr
          option.series[1] = breakDownTime_arr
          option.series[2] = processTime_arr
          option.series[3] = stopTime_arr
      }
    }
}
</script>
<style lang="scss" scoped>
.machine-id{
  width: 90%;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
  margin: 0 auto;
}
.canvas-box {
    position: relative;
    font-size: 12px;
    margin-top: 5px;
}
.btn_box {
    box-sizing: border-box;
    padding: 20px 80px;
    overflow: hidden;
}
.btn_box span {
    float: right;
    font-size: 12px;
    color: gray;
    padding: 4px 16px;
    border-radius: 16px;
    border: 1px solid #e1e7eb;
    text-align: center;
    margin-left: 10px;
    cursor: pointer;
}
.span_bg {
    background-color: #00bcc9 !important;
    color: #fff !important;
}
#desc {
    position: absolute;
    top: 75px;
    right: 85px;
    z-index: 999;
}
.time_box {
    height: 124px;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.time_box div {
    width: 25%;
    height: 124px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}
.time_box div div:nth-of-type(1) {
    height: 30px;
    width: 100%;
}
.time_box div div p {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #344347;
}
.time_box div .span1 {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 8px;
}
.time_box div .dayTime1 .span1 {
    background-color: #D5F2B1;
}
.time_box div .dayTime2 .span1 {
    background-color: #F7907C;
}
.time_box div .dayTime3 .span1 {
    background-color: #FFE4B1;
}
.time_box div .dayTime4 .span1 {
    background-color: #ccc;
}
#powerTimeAve {
    color: #D5F2B1;
}
#breakDownTimeAve {
    color: #F7907C;
}
#proTimeAve {
    color: #FFE4B1;
}
#stopTimeAve {
    color: #ccc;
}
.time_box div div:nth-of-type(2) {
    flex: 1;
    width: 100%;
    font-size: 30px;
    text-align: center;
}
#noData {
    display: inline-block;
    height: 100px;
    width: 250px;
    text-align: center;
    font-size: 25px;
    color: #ccc;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    display: none;
}
</style>
